import { api, handleError, viewSettingsApi } from '@ardoq/api';
import { ViewSettingsContexts } from '@ardoq/api-types';
import { isPresentationMode } from 'env';
import {
  distinctUntilChanged,
  EMPTY,
  from,
  map,
  Observable,
  switchMap,
} from 'rxjs';
import { loadedCurrentUser$ } from 'streams/currentUser/currentUser$';
import { mergeAndSanitizeGlobalSettings } from './utils';

export const getSavedSettings$ = <
  T extends Record<string, Record<keyof T[keyof T], unknown>>,
>(
  contextId: ViewSettingsContexts,
  defaultSettings: T
): Observable<T> =>
  loadedCurrentUser$.pipe(
    map(user => user._id),
    distinctUntilChanged(),
    switchMap(userId =>
      isPresentationMode()
        ? EMPTY
        : from(viewSettingsApi.fetchViewSettings(userId, contextId))
    ),
    handleError(error => {
      api.logErrorIfNeededAndReturnMessage(
        error,
        'Failed to fetch saved view settings'
      );
    }),
    map(settings => mergeAndSanitizeGlobalSettings(settings, defaultSettings))
  );
